import apiClient from './index'
import type { PlanningScenario } from '@/types'
import type { ListQueryParams } from './types'

// Note: Backend might use /ssp/scenarios or similar.
// Based on verify script: /ssp/scenarios/
const BASE_URL = '/ssp/scenarios'

export interface ScenarioCreate {
  name: string
  description?: string
  period_start?: string
  period_end?: string
  reinvestment_rate?: number
  procurement_lead_time_months?: number
  use_manual_dividends?: boolean
  initial_cash_balance?: number
}

export interface ScenarioUpdate {
  name?: string
  description?: string
  status?: 'draft' | 'active' | 'archived'
  period_start?: string
  period_end?: string
  reinvestment_rate?: number
  procurement_lead_time_months?: number
  use_manual_dividends?: boolean
  initial_cash_balance?: number
}

export const scenariosApi = {
  getAll: (params?: ListQueryParams) => {
    console.log('[scenariosApi] Fetching scenarios with params:', params)
    return apiClient.get<PlanningScenario[] | { items?: PlanningScenario[], results?: PlanningScenario[], data?: PlanningScenario[] }>(BASE_URL, { params })
      .then(res => {
        const data = res.data as any
        console.log('[scenariosApi] Raw response type:', typeof data)

        // Check if response is HTML (API not available)
        if (typeof data === 'string' && data.includes('<!DOCTYPE')) {
          const error = 'Backend API is not responding. Please check if backend service is running.'
          console.error('[scenariosApi]', error)
          throw new Error(error)
        }

        if (Array.isArray(data)) {
          console.log('[scenariosApi] Scenarios loaded:', data.length, 'items')
          return data
        } else if (data && typeof data === 'object') {
          console.log('[scenariosApi] Response is object, keys:', Object.keys(data))
          if (data.items) {
            console.log('[scenariosApi] Found items property:', data.items.length)
            return data.items
          }
          if (data.results) {
            console.log('[scenariosApi] Found results property:', data.results.length)
            return data.results
          }
          if (data.data) {
            console.log('[scenariosApi] Found data property:', data.data.length)
            return data.data
          }
        }
        const error = 'Unexpected API response format'
        console.error('[scenariosApi]', error, 'Response:', data)
        throw new Error(error)
      })
      .catch(err => {
        console.error('[scenariosApi] Error fetching scenarios:', err)
        throw err
      })
  },
  getById: (id: number) => apiClient.get<PlanningScenario>(`${BASE_URL}/${id}`).then(res => res.data),
  create: (data: ScenarioCreate) => apiClient.post<PlanningScenario>(BASE_URL, data).then(res => res.data),
  update: (id: number, data: ScenarioUpdate) => apiClient.put<PlanningScenario>(`${BASE_URL}/${id}`, data).then(res => res.data),
  delete: (id: number) => apiClient.delete<PlanningScenario>(`${BASE_URL}/${id}`).then(res => res.data),
  copy: (id: number, newName: string) => apiClient.post<PlanningScenario>(`${BASE_URL}/${id}/copy`, { new_name: newName }).then(res => res.data),
  activate: (id: number) => apiClient.post<PlanningScenario>(`${BASE_URL}/${id}/activate`).then(res => res.data),
}
